/* src/app/features/assets/components/asset-episode-card/asset-episode-card.component.scss */
.consent-text {
  font-size: 16px;
}
@media (min-width: 2560px) {
  .consent-text {
    font-size: 19.2px;
  }
}
@media (min-width: 3000px) {
  .consent-text {
    font-size: 23.04px;
  }
}
.font-xxsmall {
  font-size: 12px !important;
}
@media (min-width: 2560px) {
  .font-xxsmall {
    font-size: 14.4px !important;
  }
}
@media (min-width: 3000px) {
  .font-xxsmall {
    font-size: 17.28px !important;
  }
}
.font-xsmall {
  font-size: 13px !important;
}
@media (min-width: 2560px) {
  .font-xsmall {
    font-size: 15.6px !important;
  }
}
@media (min-width: 3000px) {
  .font-xsmall {
    font-size: 18.72px !important;
  }
}
.font-small {
  font-size: 14px !important;
}
@media (min-width: 2560px) {
  .font-small {
    font-size: 16.8px !important;
  }
}
@media (min-width: 3000px) {
  .font-small {
    font-size: 20.16px !important;
  }
}
.font-medium {
  font-size: 16px !important;
}
@media (min-width: 2560px) {
  .font-medium {
    font-size: 19.2px !important;
  }
}
@media (min-width: 3000px) {
  .font-medium {
    font-size: 23.04px !important;
  }
}
.font-large {
  font-size: 18px !important;
}
@media (min-width: 2560px) {
  .font-large {
    font-size: 21.6px !important;
  }
}
@media (min-width: 3000px) {
  .font-large {
    font-size: 25.92px !important;
  }
}
.font-xlarge {
  font-size: 24px !important;
}
@media (min-width: 2560px) {
  .font-xlarge {
    font-size: 28.8px !important;
  }
}
@media (min-width: 3000px) {
  .font-xlarge {
    font-size: 34.56px !important;
  }
}
.font-xxlarge {
  font-size: 28px !important;
}
@media (min-width: 2560px) {
  .font-xxlarge {
    font-size: 33.6px !important;
  }
}
@media (min-width: 3000px) {
  .font-xxlarge {
    font-size: 40.32px !important;
  }
}
.font-xxxlarge {
  font-size: 36px !important;
}
@media (min-width: 2560px) {
  .font-xxxlarge {
    font-size: 43.2px !important;
  }
}
@media (min-width: 3000px) {
  .font-xxxlarge {
    font-size: 51.84px !important;
  }
}
:root {
  --font-family: Roboto, sans-serif;
  --font-xxsmall: 12px;
  --font-xsmall: 13px;
  --font-small: 14px;
  --font-medium: 16px;
  --font-large: 18px;
  --font-xlarge: 24px;
  --font-xxlarge: 28px;
  --font-xxxlarge: 36px;
  --scale-factor-2560: 1.2;
  --scale-factor-3840: 1.2;
  --button-large: 50px;
  --button-medium: 45px;
  --button-small: 40px;
  --button-xsmall: 35px;
  --button-xxsmall: 30px;
  --header-height: 95px;
  --header-height-scrolled: 80px;
  --sidebar-width: 350px;
  --base-cover-radius: 50px;
  --base-tile-radius: 20px;
  --base-form-radius: 30px;
  --base-programme-tile-radius: 6px;
  --transition-function: cubic-bezier(0.02, 0.01, 0.47, 1);
  --transition-duration-xs: 0.15s;
  --transition-duration-sm: 0.25s;
  --transition-duration: 0.35s;
  --transition-duration-lg: 0.5s;
  --mini-details-z-index: 1100000;
  --player-z-index: 1054;
  --details-z-index: 9999999;
}
.badge-container {
  width: 160px;
  height: 0;
  position: relative;
  z-index: 3;
}
.content-item {
  font-weight: lighter;
  display: flex;
  margin-bottom: 30px;
  max-height: 90px;
  overflow: hidden;
  transition: max-height 0.8s ease;
}
.content-item.inPlayer {
  margin-bottom: 30px !important;
}
.content-item.inPlayer .content-info {
  justify-content: center;
}
.content-item .media-wrapper {
  position: relative;
  height: 90px;
  cursor: pointer;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
  display: block;
  height: 90px;
  aspect-ratio: 16/9;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.content-item .media-wrapper .media-play {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: opacity 0.3s ease;
}
.content-item .media-wrapper .media-progress-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 6px;
  width: 100%;
  z-index: 2;
  opacity: 1;
  transition: opacity 0.3s ease;
}
.content-item .media-wrapper .media-progress-fill {
  height: 100%;
  background-color: var(--player_progress_bar);
  width: 0%;
  transition: width 0.3s ease;
}
.content-item .media-wrapper::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 50%;
  background:
    linear-gradient(
      to top,
      rgba(0, 0, 0, 0.6),
      transparent);
  pointer-events: none;
  z-index: 1;
}
.content-item .content-info {
  cursor: pointer;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: flex-start;
  width: 100%;
}
.content-item .content-info .media-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  align-items: flex-start;
}
.content-item .content-info .media-header .media-title {
  font-weight: 700;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 2.8em;
  color: var(--text_secondary);
  transition: color 0.3s ease;
  flex: 1;
  min-width: 0;
}
.content-item .content-info .media-header .action-buttons img {
  width: 16px;
  height: 16px;
}
.content-item .content-info .media-header .action-buttons .media-arrow {
  width: 16px;
  height: 16px;
  transform: rotate(90deg);
  cursor: pointer;
  transition: transform 0.3s ease;
}
.content-item .content-info .media-header .action-buttons .media-favorite {
  margin-right: 30px;
}
.content-item .content-info .media-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1rem;
  width: 60%;
}
.content-item .content-info .media-description {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 2.8em;
  color: var(--text_secondary);
  transition: color 0.3s ease;
  white-space: pre-wrap;
}
.content-item .content-info .info {
  display: flex;
  color: var(--text_secondary);
  flex-wrap: wrap;
  text-align: justify;
  font-weight: normal;
}
.content-item .content-info .info > div {
  margin-right: 16px;
  align-items: center;
  display: flex;
}
.content-item .content-info .info img {
  width: 16px;
  height: 16px;
}
.content-item .content-info .info .geoblocked-areas {
  margin-top: 15px;
  color: var(--text_tertiary);
  font-size: 12px;
  width: 100%;
  display: block;
}
.content-item .content-info .credits-holder {
  margin-top: 9px;
  display: none;
}
.content-item .content-info .credits-holder .credits {
  margin-bottom: 0.5rem !important;
}
.content-item .content-info .credits-holder .credits span {
  color: var(--text_secondary);
}
.content-item .content-info.center {
  align-items: center;
  flex-direction: initial;
}
.content-item .content-info.center .media-description {
  font-weight: bold;
}
.content-item.active .media-wrapper {
  border: 2px solid var(--highlight_primary);
}
.content-item.active .content-info .media-description {
  color: var(--text_primary);
}
.content-item.active .content-info .media-header .media-title {
  color: var(--text_primary);
}
.content-item.opened {
  max-height: 2000px;
}
.content-item.opened .content-info .media-description {
  color: var(--text_primary);
  display: block;
  -webkit-line-clamp: unset;
  -webkit-box-orient: unset;
  overflow: visible;
  text-overflow: unset;
  max-height: none;
}
.content-item.opened .content-info .media-header .media-title {
  color: var(--text_primary);
  display: block;
  -webkit-line-clamp: unset;
  -webkit-box-orient: unset;
  overflow: visible;
  text-overflow: unset;
  max-height: none;
}
.content-item.opened .media-arrow {
  transform: rotate(270deg) !important;
  cursor: pointer;
}
.content-item.opened .credits-holder {
  display: block !important;
}
@media screen and (min-width: 2560px) {
  .content-item.opened {
    max-height: 2400px;
  }
}
@media screen and (min-width: 3000px) {
  .content-item.opened {
    max-height: 2880px;
  }
}
.content-item:hover .content-info .media-description {
  color: var(--text_primary);
}
.content-item:hover .content-info .media-header .media-title {
  color: var(--text_primary);
}
.content-item:hover .media-wrapper .media-play {
  opacity: 1;
}
@media screen and (min-width: 2560px) {
  .content-item {
    max-height: 108px;
    gap: 10px;
  }
  .content-item .media-wrapper {
    height: 100px !important;
  }
}
@media screen and (min-width: 3000px) {
  .content-item {
    max-height: 130px;
    gap: 10px;
  }
  .content-item .media-wrapper {
    height: 100px !important;
  }
}
@media screen and (max-width: 576px) {
  .content-item .info {
    max-width: 100% !important;
  }
  .content-item .media-wrapper {
    height: 90px !important;
  }
}
/*# sourceMappingURL=asset-episode-card.component.css.map */
